import { useI18n } from "vue-i18n";
import { configure, defineRule } from "vee-validate";
import * as AllRules from "@vee-validate/rules";

export const useCustomValidationRules = () => {
  const { t } = useI18n();

  // This will give us all the vee-validate rules and and observer components globally in our project
  Object.keys(AllRules).forEach((rule) => {
    defineRule(rule, AllRules[rule]);
  });

  // i18n configuration
  configure({
    generateMessage: (context) => {
      const regexMinMax = /^min$|^max$/
      const ruleName = context.rule.name
      let length = '';
      if (regexMinMax.test(ruleName)) {
        length = context.rule.params[0]
      }
      
      context.field = t(`fields.${context.field}`);
      const translation = t(`validations.${context.rule.name}`, {
        field: context.field,
        length: length
      });

      return translation;
    },
  });

  // Create custom rules here or override current rules. See https://vee-validate.logaretm.com/v4/guide/global-validators for more details.

  defineRule("requiredCheckBox", (value) => {
    if (!value) {
      return t("validations.termsOfServiceRequired");
    }
    return true;
  });

  defineRule("emailCreateAccount", (value) => {
    const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (!regex.test(value)) {
      return t("validations.email", {
        field: t(`fields.email`)
      });
    }
    return true;
  });

  return {};
};

export default useCustomValidationRules;
